import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const VerifiedIcon = ({ className, fill = "#12CD73" }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_178145_28854)">
        <path
          d="M17.5577 7.35011C17.4075 7.23809 17.2902 7.08762 17.2184 6.91456C17.1465 6.7415 17.1227 6.55226 17.1493 6.36678C17.4993 4.16678 17.0993 3.49178 16.7993 3.19178C16.4993 2.89178 15.8327 2.50011 13.6327 2.85011C13.4473 2.87501 13.2587 2.85034 13.0859 2.77861C12.9132 2.70688 12.7626 2.59066 12.6493 2.44178C11.1993 0.508447 10.441 0.283447 9.99935 0.283447C9.55768 0.283447 8.79935 0.508447 7.34935 2.44178C7.23614 2.59066 7.0855 2.70688 6.91277 2.77861C6.74004 2.85034 6.55138 2.87501 6.36602 2.85011C4.16602 2.50011 3.49935 2.90011 3.19935 3.19178C2.89935 3.48345 2.49935 4.16678 2.84935 6.36678C2.87603 6.55226 2.85218 6.7415 2.78031 6.91456C2.70845 7.08762 2.59123 7.23809 2.44102 7.35011C0.507682 8.80011 0.291016 9.55845 0.291016 10.0001C0.291016 10.4418 0.507682 11.2001 2.44102 12.6501C2.59123 12.7621 2.70845 12.9126 2.78031 13.0857C2.85218 13.2587 2.87603 13.448 2.84935 13.6334C2.53268 15.8501 2.89935 16.5084 3.19935 16.8084C3.49935 17.1084 4.14935 17.4668 6.36602 17.1501C6.55149 17.1234 6.74074 17.1473 6.9138 17.2192C7.08686 17.291 7.23733 17.4082 7.34935 17.5584C8.79935 19.4918 9.55768 19.7168 9.99935 19.7168C10.441 19.7168 11.1993 19.4918 12.6493 17.5584C12.7614 17.4082 12.9118 17.291 13.0849 17.2192C13.258 17.1473 13.4472 17.1234 13.6327 17.1501C15.8577 17.4668 16.4993 17.1001 16.7993 16.8084C17.0993 16.5168 17.466 15.8501 17.1493 13.6334C17.1227 13.448 17.1465 13.2587 17.2184 13.0857C17.2902 12.9126 17.4075 12.7621 17.5577 12.6501C19.491 11.2001 19.7077 10.4418 19.7077 10.0001C19.7077 9.55845 19.491 8.80011 17.5577 7.35011Z"
          fill={fill}
        />
        <path
          d="M9.58349 12.9167C9.47382 12.9173 9.3651 12.8963 9.26357 12.8548C9.16203 12.8134 9.06969 12.7523 8.99182 12.675L7.32515 11.0084C7.16823 10.8514 7.08008 10.6386 7.08008 10.4167C7.08008 10.1948 7.16823 9.98195 7.32515 9.82503C7.48207 9.66811 7.6949 9.57995 7.91682 9.57995C8.13874 9.57995 8.35157 9.66811 8.50849 9.82503L9.58349 10.9084L12.3252 8.15836C12.4026 8.08026 12.4948 8.01826 12.5963 7.97595C12.6979 7.93365 12.8068 7.91187 12.9168 7.91187C13.0268 7.91187 13.1358 7.93365 13.2373 7.97595C13.3389 8.01826 13.431 8.08026 13.5085 8.15836C13.5866 8.23583 13.6486 8.328 13.6909 8.42955C13.7332 8.5311 13.755 8.64002 13.755 8.75003C13.755 8.86004 13.7332 8.96896 13.6909 9.07051C13.6486 9.17206 13.5866 9.26423 13.5085 9.3417L10.1752 12.675C10.0973 12.7523 10.0049 12.8134 9.90341 12.8548C9.80188 12.8963 9.69316 12.9173 9.58349 12.9167Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_178145_28854">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VerifiedIcon;
